<template>
  <div class="fixed-page">
    <!-- 内容区 -->
    <div class="margin-container">
      <split-pane split="vertical" :min-percent='13' :default-percent='13'>
        <template slot="paneL">
          <!-- 左边 文件夹列表-->
          <div class="margin-left">
            <!-- <span class="title">全部文件夹</span> -->
            <el-input class="filter-search" size="small" v-model="searchFolderName" placeholder="全部文件夹" clearable>
              <svg-icon slot="prefix" class="el-input__icon icon" icon-class="search_shape" />
            </el-input>

            <!-- tree 文件夹列表 -->
            <div class="allButn" :class="currentId == 0 ? 'active' : ''" @click="handleAllClick">
              <svg-icon class="icon" icon-class="floder-blue" v-if="currentId == 0" />
              <svg-icon class="icon" icon-class="floder" v-else />
              <span class="text">{{titleName}}</span>
            </div>
            <div class="menu-box">
              <el-scrollbar wrap-class="scrollbar-wrapper">
                <el-tree ref="tree" v-loading="treeLoading" :load="loadNode" lazy :props="defaultProps" icon-class="el-icon-arrow-right" :highlight-current="true" :check-on-click-node="true" :expand-on-click-node="false"
                  node-key="id" :default-expanded-keys="defaultExpandedKeys" :current-node-key="currentId" @node-click="handleNodeClick" :filter-node-method="filterNode">
                  <div class="custom-tree-node" slot-scope="{ node, data }">
                    <svg-icon class="icon" :icon-class="currentId == data.id ? 'floder-blue' : 'floder'" />
                    <span class="text" :class="currentId == data.id ? 'active-text' : ''">{{data.folderName}}</span>
                  </div>
                </el-tree>
                <!-- <el-tree ref="tree" v-loading="treeLoading"
                                    :data="folderData"
                                    :props="defaultProps"
                                    icon-class="el-icon-arrow-right"
                                    :highlight-current="true"
                                    :check-on-click-node="true"
                                    :expand-on-click-node="false"
                                    node-key="id"
                                    :default-expanded-keys="defaultExpandedKeys"
                                    :current-node-key="currentId"
                                    @node-click="handleNodeClick"
                                    :filter-node-method="filterNode"
                                >
                                    <div class="custom-tree-node" slot-scope="{ node, data }">
                                        <svg-icon class="icon" :icon-class="currentId == data.id ? 'floder-blue' : 'floder'" />
                                        <span class="text" :class="currentId == data.id ? 'active-text' : ''">{{data.folderName}}</span>
                                    </div>
                                </el-tree> -->
              </el-scrollbar>
            </div>
          </div>
        </template>

        <template slot="paneR">
          <!-- 右边 文件列表 -->
          <div class="margin-right" @contextmenu="handleShowMenu">
            <div class="filter-box" ref="bar">
              <!-- 按钮组 -->
              <div class="filter-container butn-box">
                <el-button class="filter-data button_primary" type="primary" @click="handleUploadFiles" v-if="accessPoint['team:upload']">
                  <svg-icon icon-class="upload_shape" />
                  <span class="button_span">上传</span>
                </el-button>

                <el-button class="filter-data button_primary" type="primary" @click="handleCreate" v-if="accessPoint['team:create']">
                  <i class="el-icon-plus" />
                  <span class="button_span">新建文件夹</span>
                </el-button>

                <el-button class="filter-data button_style" :disabled="downloadDisabled" :loading="downloadLoading" @click="handleDownloadAll" v-if="accessPoint['team:download']">
                  <svg-icon icon-class="download_shape" />
                  <span class="button_span">下载</span>
                </el-button>

                <el-button class="filter-data button_style" :disabled="deleteDisabled" :loading="deleteLoading" @click="handleDeleteAll" v-if="accessPoint['team:delete']">
                  <svg-icon icon-class="delete_shape" />
                  <span class="button_span">删除</span>
                </el-button>
                <!-- 当为商务时不展示移动按钮 -->
                <el-button class="filter-data button_style" :disabled="moveDisabled" @click="initMove" v-if="accessPoint['team:delete'] && this.$store.getters.currentRoute.meta.id != 1397" >
                  <!--v-if="accessPoint['team:delete']"  <svg-icon icon-class="delete_shape" /> -->
                  <i class="el-icon-rank" />
                  <span class="button_span">移动</span>
                </el-button>

              </div>
              <!-- 筛选切换组 -->
              <div class="filter-container input_box">
                <div class="filter-left">
                  <el-input class="filter-item input_style" v-model="search" placeholder="文件名模糊查找" clearable @keyup.enter.native="handleFilter" @input="handleFilter" @clear="handleFilter" style="width:240px">
                    <svg-icon slot="prefix" class="el-input__icon icon" icon-class="search_shape" />
                  </el-input>

                  <div class="filter-data">
                    <div class="label filter-item">创建时间</div>
                    <el-date-picker class="filter-item" v-model="createTime" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="center" unlink-panels range-separator="-" start-placeholder="开始日期"
                      end-placeholder="结束日期" :picker-options="pickerOptions" @change="handleFilter" style="width:260px"></el-date-picker>
                  </div>
                </div>

                <el-radio-group class="filter-item filter-right" v-model="cutRadio" size="medium">
                  <el-radio-button label="1">
                    <el-tooltip class="item" effect="dark" content="列表" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                      <svg-icon class="icon" :icon-class="cutRadio == 1 ? 'lie_blue_shape' : 'lie_shape'" />
                    </el-tooltip>
                  </el-radio-button>

                  <el-radio-button label="2">
                    <el-tooltip class="item" effect="dark" content="平铺" placement="bottom" :visible-arrow="false" popper-class="tooltip">
                      <svg-icon class="icon" :icon-class="cutRadio == 2 ? 'big_lie_blue_shape' : 'big_lie_shape'" />
                    </el-tooltip>
                  </el-radio-button>
                </el-radio-group>
              </div>
              <!-- 面包屑导航-->
              <div style="display:flex;justify-content:space-between">
                <el-breadcrumb class="breadcrumb-box" separator-class="el-icon-arrow-right">
                  <template v-if="breadcrumbList.length > 0">
                    <el-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index">
                      <a v-if="index < breadcrumbList.length-1" class="crumb-item" href="javascript:void(0);" @click="handleGoBack(item.id,index)">{{item.folderName}}</a>
                      <span class="crumb-item-disabled" v-else>{{item.folderName}}</span>
                    </el-breadcrumb-item>
                  </template>
                </el-breadcrumb>
                 <!-- 刷新 -->
                  <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" :visible-arrow="false" popper-class="tooltip" v-if="$store.getters.currentRoute.meta.id == 1397">
                    <i class="el-icon-refresh-left" style="font-size:16px;color:#666;margin-right: 26px;cursor:pointer;height: 16px;" @click="handleFilter"/>
                  </el-tooltip>
              </div>
            </div>

            <!-- 表格列表 -->
            <file-table v-if="cutRadio == 1" ref="table" :barHeight="barHeight" :listLoading="listLoading" :sourceList="fileList" @saveFilename="handleSaveName" @cancelFilename="handleCancel"
              @imageViewer="handleImageViewer" @openFolder="handleOpenFolder" @deleteFolder="handleDeleteFolder" @downloadFolder="handleDownloadFolder" @pushFolder="handlePushFolder" @selectionTable="handleSelection">
            </file-table>
            <!-- 大图列表 -->
            <file-list v-if="cutRadio == 2" ref="list" :barHeight="barHeight" :listLoading="listLoading" :sourceList="fileList" @saveFilename="handleSaveName" @cancelFilename="handleCancel"
              @deleteFolder="handleDeleteFolder" @downloadFolder="handleDownloadFolder" @pushFolder="handlePushFolder" @imageViewer="handleImageViewer" @openFolder="handleOpenFolder" @selectionList="handleSelection">
            </file-list>

            <!-- 分页 -->
            <pagination class="pagination" v-show="total>0" :total="total" layout="total, prev, pager, next, jumper" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :autoScroll="false"
              @pagination="handlePagination" style="margin-top:0" />

          </div>
        </template>
      </split-pane>
    </div>

    <!-- 上传文件 -->
    <upload-files ref="file" source="team" @handleRefresh="handleRefresh"></upload-files>

    <!-- 移动文件 -->
    <move-files ref="moveFile" @handleMove="handleMove"></move-files>

    <!-- 创建文件夹 -->
    <el-dialog class="dialog" title="创建文件夹" :visible.sync="dialogFloder" width="500px">
      <el-form :model="floderForm" :rules="rulesFloder" ref="floderForm" label-width="120px">
        <el-form-item label="文件夹名称：" prop="folderName">
          <el-input size="small" v-model="floderForm.folderName" placeholder="请输入文件夹的名称" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="已有文件夹：">
          <!-- <el-cascader size="small" v-model="floderForm.folderPid" :options="folderOptions" :props="propsFolder" :disabled="filderDisabled" filterable clearable placeholder="请选择已有文件夹" style="width:80%"></el-cascader> -->
          <el-input v-model="folderOptions" :disabled="filderDisabled" placeholder="请选择已有文件夹" style="width:80%" size="small"></el-input>
        </el-form-item>
        <el-form-item label="选择标签：" prop="labelIds">
          <el-cascader size="small" v-model="floderForm.labelIds" :options="tagOptions" :props="props" filterable clearable collapse-tags placeholder="请选择标签" style="width:80%"></el-cascader>
        </el-form-item>
      </el-form>

      <div class="dialog-butn-box" style="margin: 30px 0 0">
        <el-button size="small" @click="dialogFloder = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="dialogLoading" @click="handleSaveCreate">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <image-viewer v-if="showViewer" source="team" :show-viewer="showViewer" :on-close="closeViewer" :url-list="[bugUrl]" :list-data="detailsData" @download="handleDownloadFolder" @share="handleShare"
      @delete="handleDeleteFolder" @push="handlePushFolder"></image-viewer>

    <!-- 链接分享 -->
    <el-dialog class="dialog" title="链接分享" :visible.sync="dialogVisible" width="35%">
      <div class="box">
        <el-input size="small" v-model="shareUrl" placeholder="请输入内容" style="width:60%"></el-input>
        <el-button size="small" v-clipboard:copy="shareUrl" v-clipboard:success="clipboardSuccess" type="primary" icon="el-icon-document">复制链接</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 右键菜单 -->
    <vue-context-menu :contextMenuData="contextMenuData" @create="handleCreate"></vue-context-menu>

    <!-- 推送 -->
    <push-list ref="push"></push-list>

  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import FileTable from './fileTable'
import FileList from './fileList'
import UploadFiles from '../uploadFiles'
import MoveFiles from '../moveFiles'
import ImageViewer from '../ImageViewer'
import Pagination from '@/components/Pagination'
import PushList from '../pushList.vue'
import clipboard from '@/directive/clipboard/index.js'
import Vue from 'vue'
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)
import { searchList_ajax, folderTreeByPid_ajax, choiceLabel_ajax, modifyFileName_ajax, modifyFolder_ajax, fileDetail_ajax, deleteFileFolder_ajax, moveFile_ajax, addFolderWithLabel_ajax } from '@File~/api/file'
import { config_folderByMenuIds, config_folderByPid } from '@File~/api/outsourcing'
export default {
  components: { splitPane, FileTable, FileList, UploadFiles, MoveFiles, ImageViewer, Pagination, PushList },
  directives: { clipboard },
  data() {
    return {
      accessPoint: this.$store.getters.accessPoint, //权限点
      searchFolderName: '', // tree搜索
      currentId: '0',
      defaultProps: {
        children: 'childList',
        label: 'folderName',
        isLeaf: 'status'
      },
      //   defaultProps: {
      //     children: 'childList',
      //     label: 'folderName'
      //   },
      titleName: this.$store.getters.currentRoute.meta.title,
      defaultExpandedKeys: [], // 默认打开的文件夹
      // 文件夹列表 
      treeLoading: false,
      folderData: [],

      // 面包屑导航
      breadcrumbList: [],

      // 文件列表
      listLoading: false,
      fileList: [],

      downloadDisabled: true, // 禁用下载
      deleteDisabled: true, // 禁用删除
      moveDisabled: true, // 禁用移动

      downloadLoading: false, // 下载loading
      deleteLoading: false, // 删除loading

      search: '', // 搜索关键词
      createTime: [],

      // 日期区间 日期
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },

          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去14天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },

      // 表格与大图切换
      cutRadio: 1,

      // 分页
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 12
      },

      // 新建文件夹
      dialogFloder: false,
      dialogLoading: false,
      floderForm: {
        folderName: '', // 文件夹名
        folderPid: [], // 已选的已有文件
        labelIds: [], // 标签
        init() {
          this.folderName = ""
          this.folderPid = []
          this.labelIds = []
        }
      },
      rulesFloder: {
        folderName: [{ required: true, message: '请输入文件夹名称', trigger: ['change', 'blur'] }], // { min: 1, max: 5, message: '长度在 3 到 5 个字符', trigger: ['change','blur']}
        labelIds: [{ required: true, message: '请选择标签', trigger: ['change', 'blur'] }]
      },
      //改造为展示文件夹名
      folderOptions: '',
      propsFolder: {
        checkStrictly: true,
        expandTrigger: 'hover',
        value: 'id',
        label: 'folderName',
        children: 'childList'
      },
      tagOptions: [],
      props: {
        multiple: true,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        children: 'labelList'
      },
      filderDisabled: true,

      // 大图展示
      showViewer: false, // 显示图片预览弹窗
      bugUrl: '', // 详情图片地址
      detailsData: {}, // 详情
      dialogVisible: false, // 复制弹窗

      shareUrl: '', // 分享地址

      // 全选
      checkedItem: [], // 已选中
      timer: null, // 定时器

      // 右键菜单数据
      contextMenuData: {
        menuName: 'menuBox',
        // 菜单显示位置
        axis: {
          x: null,
          y: null
        },

        // 菜单选项
        menulists: [
          {
            fnHandler: 'create', //绑定事件
            icoName: 'el-icon-folder', //icon图标
            btnName: '新建文件夹' //菜单名称
          }
        ]
      },

      barHeight: '0', // 筛选条件高度

      // 菜单列左右拖动
      left_width: '200px',

    }
  },
  created() {
    // this.getFolders() // 获取文件夹列表
    this.initBreadcrumb() // 初始化面包屑导航
    this.getList() // 获取列表
  },
  mounted() {
    // 窗口大小，操作栏高度变化
    window.onresize = () => {
      // console.log('1111fixedHeight', this.$refs.bar.clientHeight)
      if (this.$refs.bar) {
        this.barHeight = Number(this.$refs.bar.clientHeight + 40) + 'px'
        this.$nextTick(() => {
          if (this.cutRadio == 2) {
            this.$refs['list'].init()
          } else {
            this.$refs['table'].init()
          }
        })
      }
    }

  },
  watch: {
    // 监听table 与 列表切换
    cutRadio(val) {
      this.$nextTick(() => {
        this.barHeight = Number(this.$refs.bar.clientHeight + 40) + 'px'
        if (val == 2) {
          this.$refs['list'].init()
        } else {
          this.$refs['table'].init()
        }
      })
    },

    // 监听tree 筛选
    searchFolderName(val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    // 获取列表
    getList(folderPid, containsChildren) {
      // console.log(folderPid)
      this.listLoading = true
      const data = {
        pageNo: this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize,
        keyword: this.search, // 模糊搜索词条
        createTime: this.createTime && this.createTime.length > 0 ? this.createTime[0] + ' - ' + this.createTime[1] : '',
        folderPid: folderPid ? folderPid : null,
        menuId: this.$store.getters.currentRoute.meta.id,
        showType: 2,
        containsChildren: containsChildren ? containsChildren : 0,
        fileStatus: 1,
        inOut: this.$store.getters.synchro,
      }

      searchList_ajax(data).then(response => {
        this.listLoading = false
        if (response.code == 1) {
          const data = JSON.parse(JSON.stringify(response.data.result))
          this.fileList = data.map(v => {
            this.$set(v, 'edit', false) // 编辑
            this.$set(v, 'isMark', false) // 标记
            this.$set(v, 'originalFolderName', v.fileName) // 记录文件名

            if (v.fileType != 3) {
              const prefixLength = v.fileName.lastIndexOf("."); // 截取文件名开始到最后一个点的长度
              const prefixName = v.fileName.substring(0, prefixLength)
              const suffixName = v.fileName.substring(prefixLength, v.fileName.length) // 后缀
              // console.log('前：',prefixName)
              // console.log('后：',suffixName)
              this.$set(v, 'prefixName', prefixName)
              this.$set(v, 'suffixName', suffixName)

              this.$set(v, 'checked', false) // 选中
            }
            return v
          })
          this.total = response.data.totalCount // 总条数

          if (this.$refs.bar) {
            this.barHeight = Number(this.$refs.bar.clientHeight + 40) + 'px'
          }
          this.$nextTick(() => {
            if (this.cutRadio == 2) {
              this.$refs['list'].init()
            } else {
              this.$refs['table'].init()
            }
          })
        }
      })
    },

    // 获取已有文件夹列表
    getFolders() {
      this.treeLoading = true
      this.searchFolderName = ''
      this.folderData = this.folderOptions = []
      const folderPid = this.$store.getters.currentRoute.meta.id
      const folderName = this.$store.getters.currentRoute.meta.title
      folderTreeByPid_ajax(folderPid).then(response => {
        if (response.code == 1) {
          this.treeLoading = false
          this.folderData = JSON.parse(JSON.stringify(response.data))
          this.folderOptions = [{
            createTime: null,
            folderKey: null,
            folderName: folderName,
            folderPid: 0,
            folderStatus: null,
            id: folderPid,
            modifyTime: null,
            ownChild: false,
            childList: response.data
          }]

          this.defaultExpandedKeys = [this.currentId]
        }
      })
    },

    // 初始化面包屑导航
    initBreadcrumb() {
      this.breadcrumbList = [
        {
          createTime: null,
          folderKey: null,
          folderName: this.$store.getters.currentRoute.meta.title,
          folderPid: 0,
          folderStatus: null,
          id: this.$store.getters.currentRoute.meta.id,
          modifyTime: null,
          ownChild: false,
        }
      ]
    },

    // 获取新建文件夹 选择标签列表
    getChoiceLabel() {
      choiceLabel_ajax().then(response => {
        if (response.code == 1) {
          this.tagOptions = response.data
        }
      })
    },

    // 保存文件名修改
    handleSaveName(item) {
      if (item.fileType == 3) {
        modifyFolder_ajax(item.id, item.fileName).then(response => {
          if (response.code == 1) {
            item.edit = false
            item.fileName = response.data.folderName
            this.afterSaveName()
          }
        })
      } else {
        const folderPid = this.breadcrumbList[this.breadcrumbList.length - 1].id || this.$store.getters.currentRoute.meta.id
        const fileName = item.prefixName + item.suffixName
        modifyFileName_ajax(item.id, fileName, folderPid).then(response => {
          if (response.code == 1) {
            item.edit = false
            item.fileName = response.data.fileName
            this.afterSaveName()
          }
        })
      }

     
    },
    afterSaveName(){
      if (this.breadcrumbList.length > 1) {
        this.getList(this.breadcrumbList[this.breadcrumbList.length - 1].id)
      } else {
        this.getList()
      }

      // setTimeout(() => {
      // this.getFolders() // 获取文件夹列表
      this.updateNode()
      // }, 600)
    },

    // 取消文件名修改
    handleCancel(item) {
      item.edit = false
      item.fileName = JSON.parse(JSON.stringify(item.originalFolderName))
      // console.log('取消2222===', item)
      const prefixLength = item.fileName.lastIndexOf("."); // 截取文件名开始到最后一个点的长度
      item.prefixName = item.fileName.substring(0, prefixLength)
    },

    // 删除文件
    handleDeleteFolder(item) {
      this.$confirm('删除后，所有共享者都无法访问此文件，是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          "fileItems": [
            {
              id: item.id,
              type: item.fileType
            }
          ]
        }

        this.deleteFileFolder(data) // 删除文件接口

      }).catch(() => {

      });
    },

    // 下载文件
    handleDownloadFolder(item) {
      // 创建form 表单
      var form = document.createElement('form')
      document.body.appendChild(form)
      form.setAttribute('style', 'display:none');
      form.setAttribute('method', 'post');
      // form.setAttribute('action',apiUrl.fileUrl+'/api/file/downloadFile');//下载文件的请求路径

      form.setAttribute('action', this.$store.getters.downloadUrl );//下载文件的请求路径

      // 创建表单里 input 元素
      var tempInput = document.createElement("input");
      tempInput.type = "hidden";
      tempInput.name = 'fileId';
      tempInput.value = item.id;
      form.appendChild(tempInput);

      var tempInput2 = document.createElement("input");
      tempInput2.type = "hidden";
      tempInput2.name = 'userId';
      tempInput2.value = this.$store.getters.userId;
      form.appendChild(tempInput2);

      // console.log('表单===',form)

      form.submit()
      document.body.removeChild(form)
    },

    // 推送文件
    handlePushFolder(item) {
      // console.log('推送文件=====')
      this.$refs['push'].init(item)
    },

    // 预览大图
    handleImageViewer(item) {
      // 获取详情接口
      fileDetail_ajax(item.id).then(response => {
        if (response.code == 1) {
          const data = response.data
          if (data.fileType == 1 && data.loadFileBinaryUrl) { // 图片 显示大图
            this.bugUrl = data.loadFileBinaryUrl
          }

          if (data.fileType == 2 || data.fileType == 0) {// 视频、其它
            this.bugUrl = data.thumbnailImageUrl
          }

          if (data.fileType !== 3) {// 除文件夹外都可以打开
            this.detailsData = data
            this.showViewer = true;
          }
        }
      })
    },

    // 关闭图片预览
    closeViewer() {
      // console.log('关闭预览===')
      this.showViewer = false
      this.bugUrl = ''
      this.listData = {}
    },

    // 点击全部文件
    handleAllClick() {
      if (this.currentId == '0') return
      this.currentId = '0'
      this.$refs.tree.setCurrentKey()

      // 初始化面包屑导航
      this.initBreadcrumb()
      this.getList() // 获取列表

      let param = [this.$store.getters.currentRoute.meta.id]
      config_folderByMenuIds(param).then(response => {
        if (response.code == 1) {
          this.breadcrumbList[0].id = response.data[0].id;
        }
      })
    },

    // 点击节点
    handleNodeClick(data) {
      this.listQuery.pageNo = 1
      // console.log(data)
      if (this.currentId == data.id) return
      this.currentId = data.id
      // 初始化面包屑导航
      this.initBreadcrumb()
      this.breadcrumbList.push(data)

      const parentNode = this.$refs['tree'].getNode(data.id)
      this.getTreeNode(parentNode.parent)

      this.getList(data.id) // 获取列表
    },

    // 获取当前选中节点的父节点
    getTreeNode(node) {
      if (node && node.label !== undefined) {
        this.breadcrumbList.splice(1, 0, node.data)
        this.getTreeNode(node.parent);
      }
    },

    // 上传文件
    handleUploadFiles() {
      this.$refs['file'].init(this.breadcrumbList)
    },

    // 新建文件夹
    handleCreate() {
      this.dialogFloder = true
      this.floderForm.init()
      this.floderForm.folderPid = [this.$store.getters.currentRoute.meta.id]
      this.$nextTick(() => {
        this.$refs['floderForm'].clearValidate() // 清除验证
        this.getChoiceLabel() // 获取标签
        let tempArr = []
        this.breadcrumbList.forEach((item, index) => {

          tempArr.push(item.folderName)
          if (this.breadcrumbList.length > 1 && index > 0) {
            this.floderForm.folderPid.push(item.id)
          }
        })

        this.folderOptions = tempArr.join(' / ')
        this.filderDisabled = true // 已有文件夹禁用状态

      })
    },

    // 保存文件夹
    handleSaveCreate() {
      this.$refs['floderForm'].validate((valid) => {
        if (valid) {
          this.dialogLoading = false
          // console.log(this.floderForm.folderPid[this.floderForm.folderPid.length-1])
          let projectIds = []
          let taskIds = []
          let labelIds = []
          this.floderForm.labelIds.forEach(item => { // 标签
            if (item[0] == 'projectIds') {
              projectIds.push(item[1])
            }

            if (item[0] == "taskIds") {
              taskIds.push(item[1])
            }

            if (item[0].indexOf("labelType") > -1) {
              labelIds.push(item[1])
            }
          })

          var folderPid = null;
          if (this.floderForm.folderPid.length == 1 && this.floderForm.folderPid[this.floderForm.folderPid.length - 1] == this.$store.getters.currentRoute.meta.id) {
            folderPid = null
          } else if (this.floderForm.folderPid.length > 1) {
            folderPid = this.floderForm.folderPid[this.floderForm.folderPid.length - 1]
          } else {
            folderPid = null
          }
          const data = {
            userId: this.$store.getters.userId,
            folderName: this.floderForm.folderName,
            folderPid: folderPid,
            menuId: this.$store.getters.currentRoute.meta.id,
            projectIds: projectIds,
            taskIds: taskIds,
            labelIds: labelIds
          }

          addFolderWithLabel_ajax(data).then(response => {
            this.dialogFloder = false
            if (response.code == 1) {
              this.$message({
                message: "创建成功",
                type: "success"
              });

              this.dialogFloder = false
              this.filderDisabled = true
              if (this.breadcrumbList.length > 1) {
                this.getList(this.floderForm.folderPid[this.floderForm.folderPid.length - 1])
              } else {
                this.getList()
              }
              //   this.getFolders() // 获取文件夹列表
              this.updateNode();
            }
          })
        }
      })
    },

    // 表格, 列表选中
    handleSelection(rows) {
      if (rows && rows.length > 0) {
        this.checkedItem = rows
        this.downloadDisabled = false // 批量下载按钮 是否禁用
        this.deleteDisabled = false // 批量删除按钮 是否禁用
        this.moveDisabled = false // 批量移动按钮 是否禁用
      } else {
        this.checkedItem = []
        this.downloadDisabled = true // 批量下载按钮 是否禁用
        this.deleteDisabled = true // 批量删除按钮 是否禁用
        this.moveDisabled = true // 批量移动按钮 是否禁用
      }
    },


    // 下载全部
    handleDownloadAll() {
      // if (this.$store.getters.synchro == 2) {
      //   var num = false
      //   for (var i = 0; i < this.checkedItem.length; i++) {
      //     //inOutStatus为已同步到外网的情况
      //     if (this.checkedItem[i].outFile == false) {
      //       num = true
      //       break
      //     }
      //   }
      //   if (num) {
      //     this.$message.warning("请先将文件同步至外网")
      //     return false
      //   }
      // }

      if (this.checkedItem.length > 0) {
        let count = this.checkedItem.length

        this.timer = setInterval(() => {
          if (count > 0 && count <= this.checkedItem.length) {
            count--;
            this.handleDownloadFolder(this.checkedItem[count])
          } else {
            clearInterval(this.timer);  // 清除定时器
            this.timer = null;
          }
        }, 5000)
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择要下载的文件!'
        });
      }
    },

    // 删除全部
    handleDeleteAll() {
      if (this.checkedItem.length > 0) {
        let list = []

        this.checkedItem.forEach(item => {
          list.push({
            id: item.id,
            type: item.fileType
          })
        })
        const data = {
          "fileItems": list
        }
        this.deleteFileFolder(data) // 删除文件接口
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择要删除的文件!'
        });
      }
    },

    initMove() {
      if (this.checkedItem.length > 0) {

        this.$refs['moveFile'].init()

      } else {
        this.$message({
          type: 'warning',
          message: '请先选择要移动的文件!'
        });
      }

    },

    // 删除文件 接口调用
    deleteFileFolder(data) {
      deleteFileFolder_ajax(data).then(response => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });

        // this.getFolders() // 获取文件夹列表
        this.updateNode();

        if (this.breadcrumbList.length > 1) {
          this.getList(this.breadcrumbList[this.breadcrumbList.length - 1].id)
        } else {
          this.getList()
        }

        if (this.cutRadio == 2) {
          this.$refs['list'].handleCheckAllChange(false)
        }

        if (this.showViewer) {
          this.showViewer = false
        }
      })
    },

    // 查询
    handleFilter(val) {
      this.listQuery.pageNo = 1
      const folderPid = this.breadcrumbList[this.breadcrumbList.length - 1].id
      const containsChildren = 0
      this.getList(folderPid, containsChildren)
    },

    // 分页
    handlePagination() {
      const folderPid = this.breadcrumbList[this.breadcrumbList.length - 1].id
      this.getList(folderPid)
    },

    // 面包屑导航点击
    handleGoBack(id, index) {
      this.listQuery.pageNo = 1
      // console.log(id)
      this.currentId = id
      if (index == 0) {
        this.$refs.tree.setCurrentKey()
        this.getList()
        let param = [this.$store.getters.currentRoute.meta.id]
        config_folderByMenuIds(param).then(response => {
          if (response.code == 1) {
            this.breadcrumbList[0].id = response.data[0].id;
          }
        })
      } else {
        this.defaultExpandedKeys = [this.currentId]
        this.getList(id)
      }
      this.breadcrumbList.splice(index + 1, this.breadcrumbList.length - index - 1)
    },

    // 打开文件夹
    handleOpenFolder(item) {
      // console.log(item)
      this.currentId = item.id // 左侧选中文件夹名
      this.defaultExpandedKeys = [this.currentId]
      item.folderName = item.fileName // 文件夹名
      this.breadcrumbList.push(item)
      this.$nextTick(() => {
        this.listQuery.pageNo = 1
        this.getList(item.id)
      })
    },

    // 重刷列表
    handleRefresh(val) {
      if (val) {
        this.getList(val)
      } else {
        this.initBreadcrumb() // 初始化面包屑导航
        this.currentId = '0'
        this.$refs.tree.setCurrentKey()
        this.getList()
      }
      if (this.cutRadio == 2) {
        this.$refs['list'].handleCheckAllChange(false)
      }
    },

    //确认移动
    handleMove(valObj) {

      let list = []
      this.checkedItem.forEach(item => {
        list.push(item.id)
      })
      const param = {
        "fileIds": list,//文件id集合
        "newFolderPid": valObj[valObj.length - 1],//文件移动到文件夹id
        "folderPid": this.currentId,//文件所在文件夹id
        "menuId": this.$store.getters.currentRoute.meta.id,//菜单id
      }
      moveFile_ajax(param).then(response => {
        this.$message({
          type: 'success',
          message: '移动成功!'
        });

        if (this.breadcrumbList.length > 1) {
          this.getList(this.breadcrumbList[this.breadcrumbList.length - 1].id)
        } else {
          this.getList()
        }

      })

    },

    // 分享
    handleShare(item) {
      // console.log('====分享===',item)
      this.dialogVisible = true
      this.shareUrl = item.loadFileBinaryUrl
    },

    // 拷贝
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success',
        duration: 1500
      })
    },

    // 右键菜单
    handleShowMenu() {
      console.log('右键====')
      event.preventDefault()
      var x = event.clientX
      var y = event.clientY
      // Get the current location
      this.contextMenuData.axis = {
        x, y
      }
    },

    // tree 筛选
    filterNode(value, data) {
      if (!value) return true
      return data.folderName.toLowerCase().indexOf(value.toLowerCase()) !== -1
    },

    //懒加载树方法
    async loadNode(node, resolve) {
      let paramId = '';
      if (node.level === 0) {
        //第一层特殊处理
        let param = [this.$store.getters.currentRoute.meta.id]
        await config_folderByMenuIds(param).then(response => {
          if (response.code == 1) {
            paramId = response.data[0].id;
            this.breadcrumbList[0].id = response.data[0].id;
          }
        })
      }
      //真正获取文件接口
      config_folderByPid(node.data ? node.data.id : paramId).then(response => {
        response.data.map((item) => {
          item.status = !item.ownChild
        })

        if (response.code == 1) {
          resolve(response.data)
        }
      })

    },

    //刷新某个节点下数据
    updateNode() {
      let node = {}
      if (this.currentId === '0') {
        node = this.$refs['tree'].root
      } else {
        node = this.$refs['tree'].getNode(this.currentId)
      }

      node.loaded = false;
      node.expand(); // 主动调用展开节点方法，重新查询该节点下的所有子节点

    }


  }
}
</script>

<style lang="scss" scoped>
.fixed-page {
  height: calc(100vh - 50px);
  overflow: hidden;
  background: #f0f2f5;
}
.margin-container {
  margin: 24px 32px;
  height: calc(100vh - 50px - 48px);
  background: #ffffff;
  border-radius: 4px;
  &::after {
    content: "";
    display: table;
    clear: both;
  }
}
::v-deep .splitter-pane-resizer {
  width: 1px !important;
  background: #ababab;
  margin-left: 0px !important;
  border-left: 0 !important;
  border-right: 0 !important;
}
.margin-left {
  // float: left;
  // min-width: 200px;
  height: 100%;
  padding: 20px 0;
  box-shadow: 1px 0px 0px 0px #eeeeee;
  overflow: hidden;
  .title {
    display: block;
    width: 100%;
    padding: 0 20px;
    font-size: 16px;
    color: #333333;
    line-height: 1;
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .filter-search {
    width: 90%;
    color: #333333;
    margin: 0 5% 16px;

    ::v-deep .el-input__prefix {
      width: 16px;
      height: 16px;
      margin: 8px 5px;
      .icon {
        width: 16px;
        height: 16px;
      }
    }
    ::v-deep .el-input__inner {
      padding-left: 30px;
      color: #333;
    }
  }
  .allButn {
    padding: 0 10px 0 20px;
    // width: 200px;
    height: 44px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    .icon {
      flex-grow: 0;
      margin-right: 8px;
      width: 20px;
      height: 20px;
    }
    .text {
      flex-grow: 1;
      // width: 132px;
    }
    &.active {
      background: #f0f6ff;
      .text {
        color: #3a89ff;
      }
    }
  }
  .allButn .text,
  .custom-tree-node .text {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .el-tree-node__content {
    width: 100%;
    height: 40px;
    padding-right: 10px;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 14px;
  }
  ::v-deep .el-tree-node__children .el-tree-node__content {
    width: 100%;
  }
  .custom-tree-node {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .icon {
      margin-right: 8px;
      width: 16px;
      height: 16px;
    }

    .active-text {
      color: #3a89ff;
    }
  }

  ::v-deep .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background: #f0f6ff;
  }
}
.margin-right {
  height: 100%;
  padding: 20px 24px;
  transition: margin-left 0.28s;
  // margin-left: 200px;
  overflow: hidden;
}
.filter-container {
  margin-bottom: 10px;
}
.label {
  color: #666;
}
// 按钮
.butn-box {
  ::v-deep .el-button--medium {
    padding: 10px 14px;
  }
  ::v-deep .button_style.el-button {
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    border: 1px solid #e5e5e5;
  }
  .button_span {
    margin-left: 7px;
  }
}
.input_box {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  .filter-left {
    flex-grow: 1;
    display: flex;
    flex-flow: row wrap;
  }
  ::v-deep .el-input--medium .el-input__inner,
  ::v-deep .el-range-editor--medium.el-input__inner {
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #e5e5e5;
  }
  ::v-deep .el-input__prefix {
    width: 20px;
    height: 20px;
    margin: 8px 12px 8px 12px;
    .icon {
      width: 20px;
      height: 20px;
    }
  }
  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 44px;
    color: #333;
  }
  .input_style {
    margin-right: 24px;
  }
  .filter-right {
    ::v-deep .el-radio-button--medium .el-radio-button__inner {
      padding: 7px 8px;
    }
    ::v-deep .el-radio-button__inner {
      border: 1px solid #ffffff !important;
      background: #ffffff !important;
      box-shadow: -1px 0 0 0 #ffffff !important;
      color: #666666;
    }
    ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #3a89ff;
    }
    .icon {
      width: 20px;
      height: 20px;
    }
  }
}
.breadcrumb-box {
  height: 20px;
  margin-bottom: 16px;
}
.crumb-item {
  color: #3a89ff;
}
.crumb-item-disabled {
  cursor: not-allowed;
  color: #666666;
}

.dialog {
  ::v-deep .el-cascader__search-input {
    min-width: 10%;
    margin-left: 5px;
  }
}
.pagination {
  overflow: hidden;
}

.vue-contextmenuName-menuBox {
  background: rgba(0, 0, 0, 0.59) !important;
  color: #fff;
  padding: 10px 10px;
  border-radius: 5px;
  ::v-deep .context-menu-list {
    background: transparent !important;
  }
  ::v-deep .btn-wrapper-simple {
    display: flex;
    align-items: center;
  }
  ::v-deep .btn-wrapper-simple:hover {
    color: #1890ff;
  }
}

.scrollbar-wrapper {
  overflow-x: hidden !important;
  width: 100%;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

.el-scrollbar__bar.is-vertical {
  right: 0px;
}

.el-scrollbar {
  height: 100%;
}
.menu-box {
  height: calc(100vh - 194px);
  padding-bottom: 10px;
}
</style>
